// extracted by mini-css-extract-plugin
module.exports = {"formWrapper":"style_formWrapper__Atm1G","nextBtn":"style_nextBtn__E3F23","cancelBtn":"style_cancelBtn__L4Q9A","note":"style_note__Q_gaj"};